import type { OutboundAuthCallStrategy } from './activities/checkGithubSmartlinkAccess';

/**
 * Returns the strategy to use for outbound auth calls.
 * This function is extracted to allow mocking in tests.
 * @returns The outbound auth call strategy
 */
export const getOutboundAuthStrategy = (): OutboundAuthCallStrategy => {
	return 'all-containers';
};
